'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CloseButton = require('./components/CloseButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CloseButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/close-button/index.js
// module id = 1035
// module chunks = 0